import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useAppDispatch } from 'store';

import { ILesson } from 'modules/courses';
import { $apiV2 } from 'modules/global';

import { lessonConst, setBookResource, setLessonStatus } from '..';

export const getLessonDetail = (slug?: string) => async () => {
  const { data } = await $apiV2.get(`/teacher-course/lessons/${slug}`);

  return { lesson: data?.data };
};

export const useLessonDetail = (slug?: string) => {
  const dispatch = useAppDispatch();
  const { back } = useRouter();

  const { data, ...args } = useQuery<{ lesson: ILesson }>({
    queryKey: [lessonConst.queryKeys.LESSONS_DETAIL, slug],
    queryFn: getLessonDetail(slug),
    onSuccess: ({ lesson }) => {
      dispatch(setLessonStatus(lesson.status as lessonConst.LessonStatus));
      dispatch(setBookResource(lesson.course?.book_resource));
    },
    onError: () => {
      back();
    }
  });

  return { ...data, ...args };
};
